import type { RouteRecordRaw } from "vue-router";
import { crudRoutes } from "./helpers/crudRoutes";

// Auth-only routes — inside the auth shell (requiresAuth inherited from parent)
export const certificationRoutes: RouteRecordRaw[] = [
  ...crudRoutes({
    path: "certifications",
    listComponent: () => import("@/views/Certification/Certification.vue"),
    formComponent: () => import("@/views/Certification/CertificationForm.vue"),
    extra: [
      {
        path: "/certifications/certificationHistory/:id?",
        name: "certificationHistory",
        component: () =>
          import("@/views/Certification/CertificationHistory.vue"),
        props: true,
      },
      {
        path: "/certifications/AddDocuments/:id?",
        name: "CertificationAddDocuments",
        component: () =>
          import("@/views/Certification/CertificationAddDocuments.vue"),
        props: true,
      },
      {
        path: "/certifications/AmendDocuments/:id?",
        name: "CertificationAmendDocuments",
        component: () =>
          import("@/views/Certification/CertificationAmendDocuments.vue"),
        props: true,
      },
    ],
  }),
  ...crudRoutes({
    path: "sub_certifications", // preserve underscore URL exactly
    name: "sub-certifications", // explicit name override (kebab)
    listComponent: () => import("@/views/Certification/SubCertification.vue"),
    formComponent: () =>
      import("@/views/Certification/SubCertificationForm.vue"),
  }),
];
